__turbopack_context__.v({
  "selectedClient": "SelectedClient-module__3iMtPq__selectedClient",
  "selectedClientContainer": "SelectedClient-module__3iMtPq__selectedClientContainer",
  "selectedClient__header": "SelectedClient-module__3iMtPq__selectedClient__header",
});
